import { defineSlotRecipe } from "@chakra-ui/react";

export const selectSlotRecipe = defineSlotRecipe({
  base: {
    content: {
      "&::-webkit-scrollbar": {
        display: "none",
      },
      bg: "white",
      borderRadius: "xl",
      boxShadow: "lg",
      gap: 0.5,
      maxH: "265px",
      overflowY: "auto",
      scrollbarWidth: "none",
    },
    control: {
      alignItems: "center",
      borderWidth: "0",
      display: "inline-flex",
    },
    indicator: {
      _open: {
        transform: "rotate(180deg)",
      },
      alignItems: "center",
      border: "none",
      color: "black",
      display: "flex",
      height: "20px",
      justifyContent: "center",
      outline: "none",
      transform: "translateY(1px)",
      transition: "transform 0.2s",
      width: "20px",
    },
    indicatorGroup: {
      alignItems: "center",
      cursor: "pointer",
      display: "flex",
      flexShrink: 0,
      justifyContent: "center",
      marginLeft: "0",
      px: 2,
    },
    item: {
      _hover: {
        bg: "gray.200",
        borderRadius: "l3",
      },
      borderRadius: "l2",
      cursor: "pointer",
      px: 3,
    },
    itemGroupLabel: {
      color: "fg.subtle",
      fontSize: "xs",
      fontWeight: "normal",
      lineHeight: "150%",
      mb: 1,
    },
    itemIndicator: {
      color: "black",
    },
    itemText: {
      color: "default",
      fontSize: "xs",
      fontWeight: "normal",
    },
    root: {
      display: "inline-flex",
      minWidth: "fit-content",
      width: "auto",
    },
    trigger: {
      _open: {
        color: "black",
      },
      alignItems: "center",
      backgroundColor: "white !important",
      border: "none",
      borderRadius: "xl",
      display: "flex",
      fontSize: "xs",
      gap: 2,
      height: 8,
      justifyContent: "space-between",
      lineHeight: "normal",
      minWidth: "fit-content",
      px: 2,
      py: 2,
      width: "100%",
    },
    valueText: {
      alignItems: "center",
      display: "flex",
      flex: "1",
      fontSize: "xs",
      height: "100%",
      lineHeight: "32px",
      marginRight: "28px",
      minWidth: "fit-content",
      whiteSpace: "nowrap",
    },
  },
  slots: [
    "root",
    "label",
    "positioner",
    "trigger",
    "indicator",
    "clearTrigger",
    "item",
    "itemText",
    "itemIndicator",
    "itemGroup",
    "itemGroupLabel",
    "list",
    "content",
    "control",
    "valueText",
    "indicatorGroup",
  ],
});
